import * as React from "react";

const InstagramFilled: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.44444 4H15.5556C18.0102 4 20 5.98985 20 8.44444V15.5556C20 18.0102 18.0102 20 15.5556 20H8.44444C5.98985 20 4 18.0102 4 15.5556V8.44444C4 5.98985 5.98985 4 8.44444 4ZM12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 14.4853 14.4853 16.5 12 16.5ZM12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5ZM16.5 8.5C15.9477 8.5 15.5 8.05228 15.5 7.5C15.5 6.94772 15.9477 6.5 16.5 6.5C17.0523 6.5 17.5 6.94772 17.5 7.5C17.5 8.05228 17.0523 8.5 16.5 8.5Z" fill="currentColor" />
        </svg>
    );
};

export default React.memo(InstagramFilled);
